module.exports = __webpack_public_path__ + "static/media/waipinlaoshipinyonliucheng.b0de5c53.png";